export enum NewRelicPageActions {
    APP_INITIALISED = 'appInitialised',
    APP_MULTI_REFRESH = 'appMultiRefresh',
    BOARD_NAVIGATION = 'boardNavigation',
    ELEMENT_CREATION = 'elementCreation',
    FEATURE_FORCE_DISABLE = 'featureForceDisable',
    ELEMENT_PURGE = 'elementPurge',
    FORCED_LOGOUT = 'forcedLogout',

    LOCAL_CACHE_KEYVAL_IDB_INIT = 'localCache.keyvalIdbInit',
    LOCAL_CACHE_GET_CACHED_REDUX_STATE = 'localCache.getCachedReduxState',
    LOCAL_CACHE_GET_CACHED_REDUX_STATE_CACHE_OBJECT_RETRIEVAL = 'localCache.getCachedReduxState.cacheObjectRetrieval',
    LOCAL_CACHE_GET_CACHED_REDUX_STATE_GET_PERSISTED_STATE = 'localCache.getCachedReduxState.getPersistedState',
}

export enum NewRelicCustomAttributes {
    CLIENT_LOCAL_CACHE = 'clientLocalCache',
    CLIENT_LOCAL_CACHE_REHYDRATION = 'clientLocalCacheRehydration',
    SUPPORTS_PERSISTENCE_LAYER = 'supportsPersistenceLayer',
    CLIENT_PERSISTENCE_ENABLED = 'clientPersistenceEnabled',
}
